"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function initCarousel(elem) {
  var item = elem.querySelectorAll('.js-carousel-item');
  var slides = [];
  item.forEach(function (item) {
    var image = item.getAttribute('data-image'),
        legend = item.getAttribute('data-legend');
    slides.push({
      path: image,
      legend: legend
    });
  });
  new Carousel(elem, slides, {
    auto: true
  });
}

function initSlide(elem) {
  var item = elem.querySelectorAll('.js-slides-item');
  var slides = [];
  item.forEach(function (item) {
    var image = item.getAttribute('data-image'),
        legend = item.getAttribute('data-legend');
    slides.push({
      path: image,
      legend: legend
    });
  });
  new Carousel(elem, slides, {
    type: 'slide',
    visibleSlides: 5,
    responsive: true,
    auto: true
  });
}

document.addEventListener("DOMContentLoaded", function () {
  var carousel = _toConsumableArray(document.getElementsByClassName("glide"));

  carousel.forEach(function (carousel) {
    new Glide(carousel, {
      type: 'carousel'
    }).mount();
  });
  var slider = document.getElementById("js-slider");

  if (slider) {
    initSlide(slider);
  }
});